import {
  AddEmailTemplate,
  Attachment,
  BulkPatchTemplatePayload,
  getAllTemplatesPayload,
  PatchTemplatePayload,
  previewTemplateType,
} from '../types'
import axiosInstance from '../utils/axiosInstance'
import { API_END_POINT } from '../utils/environment'

const addEmailTemplateApi = async (payload: AddEmailTemplate) => {
  return await axiosInstance.post(
    `${API_END_POINT.TEMPLATE}/v1/communications`,
    payload
  )
}
const getEmailTemplateByIdApi = async (payload: { id: number }) => {
  return await axiosInstance.get(
    `${API_END_POINT.TEMPLATE}/v1/communications/${payload.id}`
  )
}
const getAllEmailTemplatesApi = async (payload: getAllTemplatesPayload) => {
  const response = !payload?.searchText
    ? await axiosInstance.post(
        `${
          API_END_POINT.TEMPLATE
        }/v1/communications/advance?sort=isActive,DESC&page=${
          payload.page - 1
        }&size=${payload.rowsPerPage}`,
        payload?.filter,
        {
          params: {
            sort: payload?.sort,
          },
        }
      )
    : await axiosInstance.post(
        `${
          API_END_POINT.TEMPLATE
        }/v1/communications/advance?sort=isActive,DESC&page=${
          payload.page - 1
        }&size=${payload.rowsPerPage}&searchText=${
          payload.searchText
        }&filters=template_name`,
        payload?.filter,
        {
          params: {
            sort: payload?.sort,
          },
        }
      )
  return response
}

const getTemplateByCorrespondenceTypeAndProgramApi = async (
  _payload: AddEmailTemplate
) => {
  const correspondenceType = 'EMAIL'
  const programId = 2
  const serviceId = 2
  return await axiosInstance.get(
    `${API_END_POINT.TEMPLATE}/template/filter?correspondenceType=${correspondenceType}&programId=${programId}&serviceId=${serviceId}`
  )
}
const updateEmailTemplateApi = async (payload: AddEmailTemplate) => {
  return await axiosInstance.put(
    `${API_END_POINT.TEMPLATE}/v1/communications`,
    payload
  )
}

const deleteEmailTemplateByIdApi = async (payload: { id: number }) => {
  return await axiosInstance.delete(
    `${API_END_POINT.TEMPLATE}/v1/communications/${payload.id}`
  )
}

const patchSingleTemplateApi = async (payload: PatchTemplatePayload) => {
  return await axiosInstance.patch(
    `${API_END_POINT.TEMPLATE}/v1/communications/${payload.templateId}`
  )
}

const patchBulkTemplateApi = async (payload: BulkPatchTemplatePayload) => {
  return await axiosInstance.put(
    `${API_END_POINT.TEMPLATE}/v1/communications/enable?enable=${payload.enabled}`,
    payload.templateIds
  )
}
const getAllDynamicDocumentsinCommunicationTemplate = async () => {
  return await axiosInstance.get(
    `${API_END_POINT.TEMPLATE}/v1/document-template?size=200`
  )
}
const getAllStaticDocumentsinCommunicationTemplate = async () => {
  return await axiosInstance.get(`${API_END_POINT.CORE}v1/files`, {
    params: {
      page: 0,
      size: 2000,
    },
  })
}

const getAllProgramsinCommunicationTemplate = async () => {
  return await axiosInstance.get(`${API_END_POINT.CORE}programs`)
}
const addTemplateSaveAsDraftApi = async (payload: AddEmailTemplate) => {
  return await axiosInstance.post(
    `${API_END_POINT.TEMPLATE}/v1/communications/save-as-draft`,
    payload
  )
}
const getAttachmentPreview = async (payload: Attachment) => {
  return await axiosInstance.get(
    `${API_END_POINT.TEMPLATE}/v1/communications/doc-template/preview/${payload?.attachment_document_id}?caseId=${payload?.case_id}&templateId=${payload?.template_id}&editable=${payload?.editable}`
  )
}

const previewTemplateWhileCreation = async (payload?: previewTemplateType) => {
  if (!payload) return
  return await axiosInstance.post(
    `${API_END_POINT.TEMPLATE}/v1/communications/preview-data/${payload?.case_id}`,
    payload?.payload
  )
}
const stringFilterApiURL = `${API_END_POINT.TEMPLATE}/v1/communications/filter-data/`

const convertS3ToBase64 = async (sourceKey: string) => {
  return await axiosInstance.get(
    `${API_END_POINT.TEMPLATE}/v1/document-generation/convert-s3-to-base64`,
    {
      params: {
        sourceKey,
      },
    }
  )
}

export {
  addEmailTemplateApi,
  getEmailTemplateByIdApi,
  getAllEmailTemplatesApi,
  getTemplateByCorrespondenceTypeAndProgramApi,
  updateEmailTemplateApi,
  deleteEmailTemplateByIdApi,
  patchBulkTemplateApi,
  patchSingleTemplateApi,
  getAllStaticDocumentsinCommunicationTemplate,
  getAllDynamicDocumentsinCommunicationTemplate,
  getAllProgramsinCommunicationTemplate,
  addTemplateSaveAsDraftApi,
  getAttachmentPreview,
  previewTemplateWhileCreation,
  stringFilterApiURL,
  convertS3ToBase64,
}
